import LinkedIn from "../assets/social_icon/LinkedIn.png";
import Facebook from "../assets/social_icon/Facebook.png";
import Twitter from "../assets/social_icon/Twitter.png";
import YouTube from "../assets/social_icon/YouTube.png";

export const socialLinks = [
  {
    name: "LinkedIn",
    url: "https://in.linkedin.com/company/b2b-indemand-pl",
    image: LinkedIn,
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/b2bindemandpune",
    image: Facebook,
  },
  {
    name: "Twitter",
    url: "https://twitter.com/b2bindemand?lang=en",
    image: Twitter,
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@B2BinDemand728",
    image: YouTube,
  },
];